<template>
<div class="header">
    <el-container class="area-1290">
        <el-row class="header-container">
            <el-col :span="8" class="header-item logo-parent">
                <div class="logo"></div>
            </el-col>
            <!-- <el-col :span="4" class="header-item"></el-col> -->
            <!-- <el-col :span="8"> -->
                <!-- <div class="company-name">中国石油西安润滑油销售分公司</div> -->
            <!-- </el-col> -->
            <el-col :span="8" class="header-item">
                <el-row>
                    <el-col :span="4" class="header-config-item"></el-col>
                    <el-col :span="7" class="header-config-item"></el-col>
                    <el-col :span="8" class="header-config-item logined-user-parent">
                        <div>
                            <span class="logined-bg"></span>
                            <el-popover placement="top-start" title="用户名" width="100" trigger="hover" :content="user.name">
                                <span slot="reference" class="logined-user">{{user.shortName}}</span>
                            </el-popover>
                        </div>
                    </el-col>
                    <el-col :span="4" class="header-config-item setting">
                        <span @click="loginOut" class="el-dropdown-link" style="color: rgb(255, 255, 255); font-size: 14px;">退出</span>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </el-container>
</div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';
import Tool from '../assets/js/Tool.js'
import store from '../store/index'
import Cookie from 'js-cookie';
export default {
    computed: {
        ...mapGetters(['user', 'userTypeNum']),
    },
    methods: {
        loginOut() {
            clearInterval(store.state.timer);  //清除新订单计时器
            this.axios.get('/loginout').then(res => {
                Cookie.remove('xian-spl-token')
                this.$router.push({
                    'name': 'login'
                });
            })
        }
    },
}
</script>
<style scoped>
@import url(../assets/css/base.css);
.header {
    width: 100%;
    background-color: #545c64;
}
.header-container {
    width: 100%;
}
.header-item {
    height: 50px;
}
.logo-parent {
    padding-top: 8px;
    margin-left: 33%;
}
.logo {
    width: 180px;
    height: 34px;
    background-image: url(../assets/imgs/index-logo.png);
    background-size: 100% 100%;
}
.company-name {
    text-align: center;
    line-height: 50px;
    color: #fff;
    font-size: 20px;
    font-family: Microsoft YaHei;
}
.setting {
    padding-top: 14px;
    cursor: pointer;
}
.header-config-item {
    height: 50px;
}
.logined-user-parent {
    position: relative;
    padding-top: 17px;
    padding-left: 48px;
}
.logined-bg {
    position: absolute;
    top: 20px;
    left: 20px;
    display: inline-block;
    width: 14px;
    height: 14px;
    background-image: url(../assets/imgs/icon-index-user.png);
    margin-right: 3px;
}
.logined-user {
    display: inline-block;
    width: 60px;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #fff;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/component/Header.vue